<div class="fn-ui-scrollbar">
    <ng-content></ng-content>
</div>